import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _ from 'lodash';
import { SOURCE_RELATED, ITEMS, DATA } from '@rexlabs/entity-normalizer';
import { __DEV__ } from '../../utils/env';
/**
 * Push related items into their respective place in the redux store
 * @param  {Function} dispatch   Redux store action dispatcher
 * @param  {Object} relatedItems
 * @param  {Object} relatedData
 * @param  {string} uuid
 * @return {null}
 */

export function pushRelateds(dispatch, relatedItems, relatedData, uuid) {
  for (var name in relatedItems) {
    var related = relatedItems[name];

    if (!related || !related.model) {
      continue;
    }

    var relatedModel = related.model;

    if (_Array$isArray(relatedModel)) {
      // We use arrays to indicate 1:n relationships
      //  So wee need to strip these here!
      relatedModel = relatedModel[0];
    }

    if (!_.get(relatedModel, 'actionCreators.pushItems')) {
      continue;
    }

    if (!relatedData[relatedModel.modelName]) {
      if (__DEV__) {
        console.warn("No data found for related record(s) with key \"".concat(name, "\"!"));
      }

      continue;
    }

    var items = [];

    for (var id in relatedData[relatedModel.modelName][ITEMS]) {
      items.push(relatedData[relatedModel.modelName][ITEMS][id][DATA]);
    }

    if (items.length > 0) {
      dispatch(relatedModel.actionCreators.pushItems({
        items: items,
        uuid: uuid,
        source: SOURCE_RELATED
      }));
    }
  }
}